import AttributeCommand from '@ckeditor/ckeditor5-basic-styles/src/attributecommand';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export class IpexAiUndo extends Plugin {
    init() {
        const editor = this.editor;
        const ipexAiUndo = 'ipexAiUndo';
        editor.ui.componentFactory.add(ipexAiUndo, () => {
            const button = new ButtonView();
            button.set({
                withText: false,
                icon: `<svg class="svg-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
                        </svg>`,
                class: 'ck-ipex-ai-undo-button',
                label: ipexAiUndo
            });

            // we need to catch this command later
            editor.commands.add(ipexAiUndo, new AttributeCommand(editor, ipexAiUndo));

            // undo button execution
            button.on('execute', () => {
                editor.fire(ipexAiUndo);
            });

            return button;
        });
    }
}
